import React from 'react';
import { ICONIFY } from '../../../../../Constants/iconify';
import CommonNode from '../../shared/CommonNode';
import NodeWrapper from '../../shared/NodeWrapper';

function TextAreaNode({ data }) {
    return (
        <NodeWrapper nodeId={data?.id}>
            <CommonNode data={data} icon={ICONIFY.TEXT_AREA} />
        </NodeWrapper>
    );
}

export default React.memo(TextAreaNode)
